import * as React from "react";
import {PaymentMethod} from "../../../../model/payment/Payment";

interface IProps {
	value: PaymentMethod;
}

export const PaymentMethodPresenter: React.SFC<IProps> = (props) => {
	return (
		<span>{PaymentMethod[props.value as any]}</span>
	);
};
